import { Navigate } from "react-router-dom";
// layouts
import DashboardLayout from "./layouts/dashboard";
import DashboardApp from "./pages/DashboardApp";
import Egresos from "./pages/Egresos";
import Login from "./pages/Login";
import LogoOnlyLayout from "./layouts/LogoOnlyLayout";
import Movimientos from "./pages/Movimientos";
import Personas from "./pages/Personas";
import Plazas from "./pages/Plazas";
import Reportes from "./pages/Reportes";
import ReportexFechas from "./sections/@reporteador/ReportexFechas";
import ReportesDelegado from "./sections/@reporteador/ReportesDelegado";
import Bancos from "./pages/Bancos";
import BancosMovimientos from "./pages/BancosMovimientos";
import Reportes2 from "./pages/Reportes2";
import ReporteEgresos from "./pages/ReporteEgresos";
import Catalogos from "./pages/Catalogos";
import ConceptosBanco from "./pages/catalogos/ConceptosBanco";
import ConceptoEgresos from "./pages/catalogos/ConceptosEgresos";
import EgresosSubCuentas from "./pages/catalogos/EgresosSubcuentas";
import Balance from "./pages/Balance";
import FlujoCaja from "./pages/FlujoCaja";

const routes = (isLogedIn) => [
  {
    path: "/dashboard",
    element: <DashboardLayout />,
    children: [
      { path: "app", element: <DashboardApp /> },
      {
        path: "personas",
        element: <Personas />,
      },
      {
        path: "movimientos",
        element: <Movimientos />,
      },
      {
        path: "egresos",
        element: <Egresos />,
      },
      {
        path: "plazas",
        element: <Plazas />,
      },
      {
        path: "reportes",
        element: <Reportes2 />,
      },
      {
        path: "reportegeneral",
        element: <Reportes />,
      },
      {
        path: "reporteegresos",
        element: <ReporteEgresos />,
      },
      {
        path: "reportes/rfechas",
        element: <ReportexFechas />,
      },
      {
        path: "balance-general",
        element: <Balance />,
      },
      {
        path: "flujo", 
        element: <FlujoCaja/>,
      },
      {
        path: "reportes/rdelegados",
        element: <ReportesDelegado />,
      },
      {
        path: "bancos",
        element: <Bancos />,
      },
      {
        path: "bancos/detalle/:id",
        element: <BancosMovimientos />,
      },
      {
        path: "catalogos",
        element: <Catalogos />,
      },
      {
        path: "catalogos/cbancarrios",
        element: <ConceptosBanco />,
      },
      {
        path: "catalogos/conceptosegreso",
        element: <ConceptoEgresos />,
      },
      {
        path: "catalogos/subcuentas",
        element: <EgresosSubCuentas />,
      },
    ],
  },
  {
    path: "/",
    element: <LogoOnlyLayout />,
    children: [
      { path: "/", element: <Navigate to="/dashboard/app" /> },
      //{path: "/", element: <Navigate to={`${isLogedIn[0].path}`}/>},
      { path: "login", element: <Login /> },

      // { path: "404", element: <NotFound /> },
      // { path: "*", element: <Navigate to="/404" /> },
    ],
  },
  // { path: "*", element: <Navigate to="/404" replace /> },
];

export default routes;
